import classNames from "classnames";

export function GuildIcon(props: {
	hash: string;
	server_id: string;
	// From bulma images
	width?: 16 | 24 | 32 | 48 | 64 | 96 | 128;
}) {
	const width = props.width ?? 24;

	return (
		<figure
			className={classNames(
				"image flex-shrink-0",
				`is-${width}x${width}`
			)}
		>
			<img
				className="is-rounded"
				src={`https://cdn.discordapp.com/icons/${props.server_id}/${props.hash}.webp`}
				width={width}
				height={width}
			/>
		</figure>
	);
}
